import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './SearchWrapper.module.css';
import classNames from '../../utils/classNames';
const SearchWrapper = ({ children, className, wrapperRef, active, width, widthActive, }) => {
    const searchWrapperRef = React.createRef();
    wrapperRef(searchWrapperRef);
    return (_jsx("div", Object.assign({ className: classNames(styles.root, className), style: { width: active ? widthActive : width } }, { children: _jsx("div", Object.assign({ ref: searchWrapperRef, className: classNames(styles.wrapper, active ? styles.wrapperOpen : null) }, { children: children }), void 0) }), void 0));
};
export default SearchWrapper;
